// AUTO-GENERATED — do not edit manually, run npm run icons
import { SvgIcon, type SvgIconProps } from '@mui/material';
import Svg from '@assets/icons/link-03.svg?react';

export const Link03Icon = (props: SvgIconProps) => (
  <SvgIcon component={Svg} inheritViewBox {...props} />
);
